export default status => {
  if (status === 'ACTIVE') {
    return '#ffe0b1';
  } if (status === 'PAID') {
    return '#ececff';
  } if (status === 'CANCELLED') {
    return '#e2e2e2';
  } if (status === 'DRAFT') {
    return '#e2e2e2';
  } if (status === 'CREATE') {
    return '#e2e2e2';
  } if (status === 'PROCESSING') {
    return '#e2e2e2';
  } if (status === 'INCOMPLETE') {
    return '#e2e2e2';
  } return '#ff858d';
};
